module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "prelims-page",
    attrs: {
      "id": "df42f5abd977e-d1e204"
    }
  }, [_c('span', {
    attrs: {
      "id": "pageii"
    }
  }, [_c('h3', {
    staticClass: "books-by-head"
  }, [_c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("A Selection of Titles from Sarah R. Shaber")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("The Professor Simon Shaw Series")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("SIMON SAID")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("SNIPE HUNT")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE FUGITIVE KING")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE BUG FUNERAL")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("SHELL GAME")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("The Louise Pearlie Series")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("LOUISE’S WAR *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("LOUISE’S GAMBLE *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("LOUISE’S DILEMMA *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("LOUISE’S BLUNDER *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("LOUISE’S CHANCE *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_c('em', {
    staticClass: "char-italic italic"
  }, [_vm._v("* available from Severn House")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fd5255e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780107158_epub_alb.vue
// module id = 63
// module chunks = 0